<button 
    class="btn btn-secondary"
    [disabled]="isDisabled"
    (click)="exportSelected()"
    [ngbTooltip]="'Export selected domains to JSON file' | translate"
    [attr.aria-label]="'Export selected domains' | translate"
    data-test="export-selected-domains">
    <i class="fas fa-download" *ngIf="!isExporting"></i>
    <i class="fas fa-spinner fa-spin" *ngIf="isExporting"></i>
    <span class="ml-1" translate>Export Selected</span>
    <span class="ml-1" *ngIf="isExporting && progress.total > 0">({{ progress.current }}/{{ progress.total }})</span>
</button>